import React, { createContext, useRef } from 'react';

export const LayoutContext = createContext({
  mainContentRef: null,
});

export const LayoutProvider = ({ children }) => {
  const mainContentRef = useRef(null);

  return (
    <LayoutContext.Provider value={{ mainContentRef }}>
      {children}
    </LayoutContext.Provider>
  );
};
